import { TableCell } from "@mui/material";
import { useEffect, useState } from "react";
import { ReportHeader } from "../../external/ensolvers-core-frontend-mui/dto/ReportDTO";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import AvailableStaff from "../../models/AvailableStaff";
import UserService from "../../services/UserService";
import { RoleOptions } from "../../utils/enums/EnsolversOpsRoles";
import OpsDateUtils from "../../utils/OpsDateUtils";
import environment from "../../environment.json";
import { EnviromentType } from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/EnvironmentService";
import ReportTable from "../ReportTable";
import useTableHeight from "../../hooks/useTableHeight";

interface Props {
  selectedDate: Date;
  calculateMaxHeight: (hasButtons: boolean) => string;
}

export const AvailableUsersTab = ({ selectedDate, calculateMaxHeight }: Props) => {
  const [headers, setHeaders] = useState<ReportHeader[]>([]);
  const [rows, setRows] = useState<AvailableStaff[]>([]);

  useEffect(() => {
    loadHeaders();
    getAvailableStaff();
  }, [selectedDate]);

  const loadHeaders = () => {
    let headers = new Array<ReportHeader>();
    headers.push({ label: "Primary Role", align: "left" });
    headers.push({ label: "Secondary Role", align: "left" });
    headers.push({ label: "Availability", align: "left" });
    OpsDateUtils.getWeeksOfMonth(selectedDate.getFullYear(), selectedDate.getMonth()).forEach((d) =>
      headers.push({ label: `${d.startDate} - ${d.endDate}`, align: "center" })
    );
    setHeaders(headers);
  };

  const getAvailableStaff = async () => {
    (await UserService.getAvailableStaff(selectedDate.getFullYear(), selectedDate.getMonth()))
      .onSuccess((response) => setRows(response))
      .onError((err) => NotificationService.error(err));
  };

  const getKeyName = (value: string) => {
    if (value === "No role") return value;
    return Object.entries(RoleOptions).find(([key, val]) => key === value)?.[1];
  };

  const getContent = () => {
    return (
      <>
        <ReportTable<AvailableStaff>
          maxHeight={calculateMaxHeight(false)}
          stickyHeader
          headers={headers!}
          rows={rows}
          onRowClick={(row) => {
            if (environment.type !== EnviromentType.PROD) {
              console.log(row);
            }
          }}
          tableRow={(instance) => (
            <>
              <TableCell>{getKeyName(instance.primaryRole)}</TableCell>
              <TableCell>{instance.secondaryRole ? getKeyName(instance.secondaryRole) : "-"}</TableCell>
              <TableCell>{instance.availability}</TableCell>
              {Object.entries(instance.availableUsersPerWeek).map(([week, value], index) => (
                <TableCell align="center">{value}</TableCell>
              ))}
            </>
          )}
        />
      </>
    );
  };
  return getContent();
};
